var _g, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "51px",
    height: "51px",
    viewBox: "0 0 51 51",
    enableBackground: "new 0 0 51 51",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    display: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4332.414,
    y: -513.857,
    display: "inline",
    fill: "#5D5D5D",
    width: 9481.222,
    height: 9392.563
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A00089",
    d: "M33.982,11.931H17.019c-2.811,0-5.088,2.278-5.088,5.089v16.96c0,2.812,2.277,5.088,5.088,5.088h12.165 c0.899,0,1.765-0.355,2.398-0.993l6.492-6.491c0.636-0.637,0.994-1.501,0.994-2.4V17.02C39.068,14.209,36.789,11.931,33.982,11.931z  M30.588,36.669v-4.383c0-0.938,0.762-1.697,1.698-1.697h4.384L30.588,36.669z M37.374,28.893h-5.088 c-1.876,0-3.396,1.518-3.396,3.394v5.086H17.019c-1.873,0-3.39-1.517-3.392-3.392V17.02c0.002-1.875,1.519-3.39,3.392-3.393h16.963 c1.871,0.002,3.389,1.518,3.392,3.393V28.893z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#A00089",
    d: "M31.436,18.716H19.563c-0.468,0-0.848,0.379-0.848,0.851c0,0.465,0.38,0.845,0.848,0.845h11.873 c0.469,0,0.851-0.38,0.851-0.845C32.286,19.095,31.904,18.716,31.436,18.716z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#A00089",
    d: "M31.436,23.803H19.563c-0.468,0-0.848,0.38-0.848,0.851c0,0.468,0.38,0.846,0.848,0.846h11.873 c0.469,0,0.851-0.378,0.851-0.846C32.286,24.183,31.904,23.803,31.436,23.803z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/Note.6b9912cf2716faeacda5190f89a1bc51.svg";
export { ForwardRef as ReactComponent };